import { Module } from 'vuex'
import { RootState } from '@/store'
import { Image } from '@/interfaces/GeneralInterfaces'

export interface GuestLogoState {
  logos: Image[]
}

const guestLogo: Module<GuestLogoState, RootState> = {
  namespaced: true,

  state: {
    logos: []
  },
  getters: {
    getLogos (state: GuestLogoState): Image[] {
      return state.logos
    }
  },
  mutations: {
    setLogos (state: GuestLogoState, logos: Image[]): void {
      state.logos = logos
    },
    clearLogos (state: GuestLogoState): void {
      state.logos = []
    }
  }
}

export default guestLogo
